import React, { useContext, useEffect } from 'react'
import './Navbar.css'
// import { clientsRoutes, nonRoutes, shopRoutes } from '../Routes/Routes';
// import { Route } from '../Models/Route';
import { useNavigate } from 'react-router-dom';
import { AlertFilled, HomeFilled, HomeOutlined, LoginOutlined, MenuOutlined, PoweroffOutlined, ShopFilled, ShoppingFilled } from '@ant-design/icons';
import CardComponent from '../Components/CardComponent/CardComponent';
import { Monitor } from '../Models/Monitor';
import { addMonitor } from '../Api/Monitor';
// import NavBarItem from './NavBarItem';

interface Props{
    setOpen:React.Dispatch<React.SetStateAction<boolean>>
}

const Navbar = ({setOpen}:Props) => {
    // const [routes, setRoutes] = React.useState<Route[]>(clientsRoutes);
    const navigate = useNavigate();

      const sendMonitor = async (seccion:string)=>{
          try
          {let user:string= localStorage.getItem("user") || ""

          let monitor:Monitor={
              action:`Cambio de seccion ${seccion}`,
              user:user
          }
          await addMonitor(monitor)}
          catch(error){}
      }
      
  return (
    <div className='Navbar-element'>

    <div className='NavBar-Component'>

        <div className='Navbar-Menu'>
            <MenuOutlined onClick={()=>{setOpen(true)}} style={{cursor:"pointer", color:"#FFF"}} />
        </div>

        <div className='Navbar-logo'>
            <img src='/logo.png' alt='Logo frikistore' />
        </div>

        <div className='Navbar-items-menu'>

        {/* <div className='Navbar-item-menu' onClick={() =>{navigate("/")}}>
            <span>Inicio</span>
        </div> */}

        <div className='Navbar-item-menu' onClick={() =>{sendMonitor("/productos"); navigate("/productos")}}>
            {/* <ShopFilled /> */}
            <span>Productos</span>
        </div>

        <div className='Navbar-item-menu' onClick={() =>{sendMonitor("/proximamente");navigate("/proximamente")}}>
            {/* <AlertFilled /> */}
            <span>Proximamente</span>
        </div>

        <div className='Navbar-item-menu' onClick={() =>{sendMonitor("/cartas");navigate("/cartas")}}>
            {/* <AlertFilled /> */}
            <span>Cartas</span>
        </div>

   
    </div>


        
        <CardComponent ></CardComponent>
    </div>

    {/* <div className='Navbar-items'>

        <div className='Navbar-item'>
            <HomeFilled />
            <span>Inicio</span>
        </div>

        <div className='Navbar-item'>
            <ShopFilled />
            <span>Productos</span>
        </div>

        <div className='Navbar-item'>
            <AlertFilled />
            <span>Proximamente</span>
        </div>

    </div> */}
    {/* <div className='sub-navbar'>
        <span>Obtén hasta un 40% de descuento al pagar con Divisas, Zelle, Binance o PayPal. Además, recibe Delivery o Envío GRATIS por MRW en todas las compras mayores o iguales a $50.</span>
    </div> */}
    </div>

  )
}

export default Navbar